import { CommunicationFlowCreate } from "./communicationFlowCreate";
import { CommunicationFlowEdit } from "./communicationFlowEdit";
import { CommunicationFlowList } from "./communicationFlowList";

export default {
	create: CommunicationFlowCreate,
	edit: CommunicationFlowEdit,
	list: CommunicationFlowList,
};
